// Others
import axiosClient from './axiosClient';
import { urlApiFile } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IDocument, IFile } from '~/utils/interface/document';
import { IQueryParamListFile } from '~/utils/interface/file';

const fileApi = {
  uploadMultipleFileAndGetLink: (payload: FormData) => {
    const url = urlApiFile.uploadMultipleFileAndGetLink;
    return axiosClient.post<IBaseResponse<IFile[]>>(url, payload, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getListFile(params: IQueryParamListFile) {
    const url = urlApiFile.getListFile;
    return axiosClient.get<IBaseResponse<IListDataResponse<IDocument[]>>>(url, { params });
  },
};

export default fileApi;
